import { Pill } from '@bridebook/ui';
import { Plus } from '@bridebook/aura/src/icons';
import { RsvpQuestion } from '@bridebook/web/lib/rsvp/types';
import { isSameRsvpQuestion } from '@bridebook/web/lib/rsvp/utils/is-same-rsvp-question';
import { useGetPopularRsvpQuestions } from '@bridebook/web/lib/rsvp/hooks/use-get-popular-rsvp-questions';
import { Icon } from '@bridebook/aura';
import styles from '@bridebook/web/components/wedding-website/rsvp/question-form/partials/pill-list.style';

type PillListProps = {
  onAdd: (question: RsvpQuestion) => void;
  currentQuestion: RsvpQuestion;
};

export const PillList = ({ onAdd, currentQuestion }: PillListProps) => {
  const popularRsvpQuestions = useGetPopularRsvpQuestions();
  return (
    <>
      {popularRsvpQuestions.map((q) => {
        const isSelected = isSameRsvpQuestion(currentQuestion, q);
        return (
          <Pill
            key={q.question}
            bordered
            color={isSelected ? 'indigoCrush' : 'space40'}
            style={styles.pill}
            onClick={isSelected ? undefined : () => onAdd(q)}>
            <Icon
              icon={Plus}
              size={16}
              className={isSelected ? 'text-indigo-crush' : 'text-space'}
            />
            {q.question}
          </Pill>
        );
      })}
    </>
  );
};
